import { ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IDashboard } from "../interfaces/idashboard";
import { DashboardService } from "../services/dashboard.service";
import { Observable, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { AuthService } from "../services/auth.service";

@Injectable()
export class DashboardResolver {

    constructor(private dashboardService: DashboardService) {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<IDashboard> {
               
        // Log authentication state at resolver level
               
        
        
        // todo - replace with parameter
        // return this.dashboardService.getDashboard(route.params.id);
        return this.dashboardService.getDashboard().pipe(
            tap(() => {
                
            }),
            catchError((error) => {
                
                if (error.status === 401) {
                }
                
                throw error; // Re-throw to let Angular handle navigation failure
            })
        );
    }
}